module.exports = __webpack_public_path__ + "static/ofcar10-7e9590b11b3ff306fc22330a67dd1d38.jpg";